import styled from "styled-components";
import { device } from "../device";

export const CompanyWithSidebarLayout = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    min-height: 90vh;
`;

export const GridTileContainer = styled.div`
    position: relative;
    padding: 20px 0px 20px 0px;
    @media ${device.tablet} {
        padding: 32px 24px 24px 32px;
    }
    
    height: 100%;
    flex: 1;
    background-color: ${(props) => props.theme.colors.lightBg};

    h1 {
        margin-top: 0;
        margin-bottom: 25px;
        font-size: 36px;
        font-weight: 700;
    }

    .container-margin {
        margin-bottom: 25px;
    }
`;